<template>
  <v-form ref="form1" lazy-validation v-if="employee">
      <MessageBox class="mb-5" type="info" v-if="employee.isProtected">
        <h6>{{ $t('company.employee.protected-title') }}</h6>
        <p>{{ $t('company.employee.protected-text-2') }}</p>
        <ul>
          <li>
            <p>{{ $t('company.employee.protected-sub-text-1') }}</p>
          </li>
          <li>
            <p>{{ $t('company.employee.protected-sub-text-2') }}</p>
          </li>
        </ul>
      </MessageBox>

    <v-text-field v-if="! employee.apprentice"
      class="pt-4"
      outlined
      :disabled="!isEditable"
      v-model="employee.roleDescription"
      :label="$t('fields.roleDescription')"
    ></v-text-field>
    <v-text-field
      outlined      
      :disabled="!isEditable"
      v-model="employee.email"
      :rules="[rules.required, rules.email]"
      :label="$t('fields.email')"
    ></v-text-field>
    <v-text-field
      outlined
      :disabled="!isEditable"
      v-model="employee.mobilephone"
      :rules="[rules.required, rules.phone]"
      :label="$t('fields.mobilephone')"
    ></v-text-field>

    <v-text-field
      outlined
      append-icon="$sl-view"
      readonly
      class="v-input--is-readonly--light"
      @click:append="showPersonalnumber"
      v-model="employee.maskedPersonalnumber"
      :label="$t('fields.personalnumber')"
    ></v-text-field>
     <!-- used to submit the form -->
    <ActionButton class="mt-4" 
      @click="save()" 
      actionIcon="$sl-save"
      :isDisabled="!isEditable || isImitatingUser()"
    >
      {{$t('labels.save')}}
    </ActionButton>
  </v-form>
</template>

<script>
import {mapGetters} from "vuex"
import ActionButton from '@/components/Common/ActionButton'
import {RulesMixin} from '@/components/mixins'
import MessageBox from '@/components/Common/MessageBox.vue'

// @group Company
// CompanyEmployeeContact component
export default {
  name: 'CompanyEmployeeContact',

  mixins: [RulesMixin],

  props: {
    // employee object
    emp: {
      // `Object` 
      type:Object
    },
    // Should fields be editable
    isEditable: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    }
  },
  components: {
    ActionButton,
    MessageBox
  },
  watch: {
    /**
   * @vuese
   * Used to watch employee and call init function
   * @arg called with no argument
   */
    emp() {
      this.init()
    }
  },
  data: () => ({
    employee: {}
  }),

  mounted() {
    this.$scrollToTop()
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('currentuser', ['isImitatingUser']),
  },
  methods: {
     /**
     * @vuese
     * Used to set props to varible
     */
    init() {
      this.employee = this.emp      
    },
     /**
     * @vuese
     * Used to save employee if form is valid and emit the employee object
     */
    save() {
      if (!this.$refs.form1.validate()) {
        this.$events.fire('showError', this.$t('errors.form-validation'))
        return
      }
      // Fire employee object
      // @arg The argument is object representing employee object
      this.$emit('save', this.employee)
    },
    /**
     * @vuese
     * Used to add mask to personal number
     */
    showPersonalnumber() {      
      this.employee.maskedPersonalnumber =
        this.employee.personalNumber.substring(0, 8) + '-' + this.employee.personalNumber.substring(8, 12)

      return new Promise(resolve => {
        setTimeout(() => {
          this.employee.maskedPersonalnumber = this.employee.personalNumber.substring(0, 8) + '-****'
        }, 5000)
      })
    }
  }
}
</script>